import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTestTube2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTestTube2"><Path d="M21 21H13V19.5H19.5V14H21V21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21.2803 9.71973L20.2197 10.7803L19.25 9.81055L9.78027 19.2803C8.38284 20.6775 6.11715 20.6775 4.71973 19.2803C3.32246 17.8828 3.32247 15.6172 4.71973 14.2197L14.1895 4.75L13.2197 3.78027L14.2803 2.71973L21.2803 9.71973ZM10.0605 11H15.9395L18.1895 8.75L15.25 5.81055L10.0605 11Z" fill="currentColor"/><Path d="M10 4.5H4.5V11H3V3H10V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTestTube2;
